export const timer = (beforeFunction, afterFunction, timer) => {
  beforeFunction();
  const interval = setInterval(() => {
    afterFunction();
  }, timer);
  return () => clearInterval(interval);
};
